import { Pause } from "@phosphor-icons/react";
import { GlassIcon } from "@/components/site/SiteBits";

const SHARDS = [[-60, -40, -120], [50, -46, 160], [70, 30, 90], [-40, 44, -70], [16, -60, 200], [-80, 8, -160]];

function Glass({ label, className, testId }) {
  return (
    <div className={`g-layer ${className}`} data-testid={testId}>
      <div className="g-layer g-under" />
      <div className="g-layer g-glass">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/30"><GlassIcon size={22} /></span>
        <span className="min-w-0"><b className="block text-[13px]">{label.title}</b><span className="block text-[11px] leading-tight opacity-80">{label.line}</span></span>
      </div>
      <svg className="g-crack" viewBox="0 0 240 96" preserveAspectRatio="none" aria-hidden>
        <g stroke="white" strokeWidth="1.4" fill="none" opacity=".95">
          <path d="M168 48 L120 10 M168 48 L230 18 M168 48 L210 92 M168 48 L118 78 M168 48 L80 52 M140 26 L150 8 M196 70 L230 66" />
        </g>
      </svg>
      <span className="g-ripple" />
      {SHARDS.map(([dx, dy, r], i) => <span key={i} className="g-shard" style={{ "--dx": `${dx}px`, "--dy": `${dy}px`, "--r": `${r}deg` }} />)}
    </div>
  );
}

// Break my glass loop (~14s): voice glass → tap/crack/shards → voice playing → video glass → tap/crack → video playing → repeat.
// Reduced motion: the voice-playing state, still (site.css).
export default function GlassDemo({ copy }) {
  const title = copy.glass_tile_break;
  return (
    <div className="g-stage" data-testid="glass-demo" role="img" aria-label={`${title}: ${copy.glass_tile_voice}`}>
      <div className="g-layer g-voice g-voice-play" data-testid="glass-demo-voice">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[var(--s-coral)] text-white"><Pause size={16} weight="fill" /></span>
        <div className="min-w-0 flex-1">
          <div className="g-bars">{Array.from({ length: 22 }, (_, i) => <i key={i} style={{ animationDelay: `${(i % 7) * 0.11}s`, height: `${40 + ((i * 37) % 60)}%` }} />)}</div>
          <div className="g-progress mt-1.5"><span /></div>
        </div>
      </div>
      <div className="g-layer g-video g-video-play" data-testid="glass-demo-video">
        <span className="w-fit rounded-full bg-black/35 px-2 py-0.5 text-[9px] font-bold tracking-[0.12em]">{copy.glass_tile_video_tag}</span>
        <div className="g-progress"><span /></div>
      </div>
      <Glass className="g-video-glass" label={{ title, line: copy.glass_tile_video }} testId="glass-demo-video-glass" />
      <Glass className="g-voice-glass" label={{ title, line: copy.glass_tile_voice }} testId="glass-demo-voice-glass" />
    </div>
  );
}
